import { useQuery } from '@tanstack/react-query';
import { useAuthenticatedApi } from '../api';
import { useAuth0 } from '@auth0/auth0-react';

const fetchHomeAds = async (authenticatedFetch, type) => {
  const url = type
    ? `${process.env.REACT_APP_API_URL || '/api'}/ads?type=${encodeURIComponent(type)}`
    : `${process.env.REACT_APP_API_URL || '/api'}/ads`;
  const response = await authenticatedFetch(url);

  if (!response.ok) {
    throw new Error('Failed to fetch ads');
  }

  const data = await response.json();
  return data.ads || [];
};

export const useHomeAds = (options = {}) => {
  const { type } = options; // e.g. 'course' for course ads
  const { authenticatedFetch } = useAuthenticatedApi();
  const { isAuthenticated, isLoading: authLoading } = useAuth0();

  return useQuery({
    queryKey: ['homeAds', type],
    queryFn: () => fetchHomeAds(authenticatedFetch, type),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
    refetchOnWindowFocus: false,
    enabled: !authLoading && isAuthenticated && !!authenticatedFetch
  });
};
